export function nav() {
	const body = document.querySelector('body')
	const navButton = document.querySelector('.nav__button')
	const siteHeader = document.querySelector('.site__header')

	function toggleMenu() {
		if (body.classList.contains('js-nav-open')) {
			body.classList.remove('js-nav-open')
			navButton?.classList.remove('is-active')
		} else {
			body.classList.add('js-nav-open')
			navButton?.classList.add('is-active')
		}
	}

	document.querySelectorAll('.js-nav__button').forEach((item) => item.addEventListener('click', toggleMenu))
	document.querySelectorAll('.nav__site li:not(.has-children)').forEach((item) => item.addEventListener('click', toggleMenu))

	// hide header on scroll down ==========================================
	var didScroll
	var lastScrollTop = 0
	var delta = 20

	document.addEventListener('scroll', function () {
		didScroll = true
	})

	if (siteHeader) {
		siteHeader.classList.add('nav-down')

		setInterval(function () {
			if (didScroll) {
				if (!navButton?.classList.contains('is-active')) {
					hasScrolled()
				}
				didScroll = false
			}
		}, 250)
	}

	function hasScrolled() {
		if (!siteHeader) return

		var st = window.pageYOffset !== undefined ? window.pageYOffset : (document.documentElement || document.body.parentNode || document.body).scrollTop

		// Make sure they scroll more than delta
		if (Math.abs(lastScrollTop - st) <= delta) return

		// If they scrolled down and are past 50vh, add class .nav-up.
		// This is necessary so you never see what is "behind" the navbar.
		if (st > lastScrollTop && st > window.innerHeight / 2) {
			// Scroll Down
			siteHeader.classList.remove('nav-down')
			siteHeader.classList.add('nav-up')
		} else {
			// Scroll Up
			siteHeader.classList.remove('nav-up')
			siteHeader.classList.add('nav-down')
		}

		lastScrollTop = st
	}

	// Add ESC key handler
	document.addEventListener('keydown', function(event) {
		if (event.key === 'Escape') {
			if (body.classList.contains('js-nav-open')) {
				body.classList.remove('js-nav-open')
				navButton?.classList.remove('is-active')
			}
		}
	})
}
